
function Distribution(options) {
    var self = this,
        data = {},
        total = 0,
        maxTotal = 0,
        i;

    options = options || [];
    this.options = options;

    function updateTotal() {
        total = Array.prototype.reduce.call(options, function(a, b) {
            return a + (data[b] || 0);
        }, 0);
    }

    function makeProperty(name, getter, setter) {
        Object.defineProperty(self, name, {
            enumerable: true,
            configurable: false,
            get: getter,
            set: setter
        });
    }

    function getCategoryValue(name) {
        return data[name] || 0;
    }

    function setCategoryValue(name, value) {
        var maxValue = maxTotal - (total - (data[name] || 0));
        value = parseInt(value, 10) || 0;
        value = Math.max(0, Math.min(value, maxValue));
        data[name] = value;
        updateTotal();
    }

    makeProperty('total', function() { return total; });
    makeProperty('uncategorized', function() { return maxTotal - total; });
    makeProperty('data', function() { return data; }, function(values) {
        values = values || {};
        for(var i = 0; i < options.length; i++) {
            self[options[i]] = values[options[i]] || 0;
        }
    });
    makeProperty('maxTotal', function() { return maxTotal; }, function(value) {
        maxTotal = value;
        self.data = data;
    });

    for (i = 0; i < options.length; i++) {
        makeProperty(options[i],
                     angular.bind(self, getCategoryValue, options[i]),
                     angular.bind(self, setCategoryValue, options[i]));
    }
}



module.directive('categoryDistribution', function(ModelConfig) {
    return {
        restrict: 'E',
        require: 'ngModel',
        templateUrl: 'util/input/categoryDistribution',
        scope: {
            total: '=',
            unit: '@',
            label: '@',
            options: '=?',
            uncategorizedName: '@',
        },
        link: function(scope, element, attrs, ngModel) {
            scope.data = new Distribution([]);

            ngModel.$render = function() {
                if (!angular.equals(scope.options, scope.data.options)) {
                    scope.data = new Distribution(scope.options);
                    scope.data.maxTotal = scope.total;
                }
                if (ngModel.$viewValue === ngModel.$viewValue && scope.options) {
                    scope.data.data = ngModel.$viewValue;
                    scope.change();
                }
            };

            scope.change = function() {
                var data = angular.copy(scope.data.data);
                data.uncategorized = scope.data.uncategorized;
                ngModel.$setViewValue(data);
            };

            if (!attrs.options) {
                scope.options = ModelConfig.getOpions(attrs.name);
            }

            scope.$watchCollection('options', ngModel.$render);

            scope.$watch('total', function(total) {
                scope.data.maxTotal = total;
            });
        }
    };
});
